const PUBLIC_ROUTE_PATTERNS = [
  /^\/auth(?:\/|$)/,
  /^\/signup(?:\/|$)/,
  /^\/welcome(?:\/|$)/,
  /^\/activate(?:\/|$)/,
  // Served by Router.tsx outside ProtectedRoutes, so they must not bounce logged-out users to login
  /^\/onboard(?:\/|$)/,
  /^\/logout(?:\/|$)/,
  /^\/404$/,
  /^\/heavy-load$/,
];

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTE_PATTERNS.some((route) => route.test(pathname));
}
